<template>
  <v-card>
    <v-card-title>
      <router-link
        :to="{
          name: 'intervention_form',
          params: { user_id: userId },
        }"
      >
        <v-btn fab class="mt-n4" :color="color" v-if="can_edit()">
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </router-link>

      <p class="pl-5">
        <v-row
          ><v-img
            class="pl-5"
            src="/icons/intervention.png"
            :aspect-ratio="1"
            width="40"
          />{{ $tc("intervention.title", 2) }}</v-row
        >
      </p>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="interventions"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :options.sync="options"
      :server-items-length="$store.state.intervention.totalCount"
      dense
      show-expand
    >
      <template v-slot:expanded-item="{ headers }">
        <td class="pt-5" :colspan="headers.length"></td>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>
      <template #item.actions="{ item }">
        <v-btn small icon @click.prevent="remove('intervention', item)">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
      <template #item.date="{ item }">
        {{ item.date | date }}
      </template>
      <template #item.types="{ item }">
        {{ item.count_types }}
      </template>
      <template #item.done="{ item }">
        {{ item.count_done }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td class="pt-5 pb-5" :colspan="headers.length">
          <div v-for="(obj, index) in item.types" :key="index">
            <b>{{ obj.type.name }}</b
            >: {{ obj.count }}<br />
          </div>
          <div v-if="item.comment">
            <span class="font-weight-bold"
              >{{ $t("intervention.comment") }}:</span
            >
            <p class="pre-formatted">
              {{ item.comment | capitalize }}
            </p>
          </div>
        </td>
      </template>

      <template #item.actions="{ item }">
        <EditDelete
          @delete="remove('intervention', item)"
          :edit-path="{
            name: 'intervention_form_edit',
            params: { intervention_id: item.id, user_id: userId },
          }"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"
import EditDelete from "@/components/form/EditDelete"

const { mapActions } = createNamespacedHelpers("intervention")

export default {
  name: "interventionsTable",
  components: { EditDelete },
  mixins: [TableMixin],
  data: function () {
    return {
      options: {},
    }
  },
  computed: {
    interventions() {
      return this.$store.state.intervention.data
    },

    headers() {
      let result = [
        {
          value: "date",
          text: this.$tc("common.date", 1),
          sortable: true,
          align: " text-no-wrap",
        },

        {
          value: "types",
          text: this.$tc("intervention.count_type", 1),
          width: "45%",
          sortable: true,
        },
        {
          value: "done",
          text: this.$tc("intervention.count_done", 1),
          width: "45%",
          sortable: false,
        },
      ]
      if(this.can_edit()) {
        result.push({
          value: "actions",
          align: "right",
        })
      }

      return result
    },
  },
  watch: {
    "$route.params.user_id"() {
      // call the method which loads your initial state
      console.log("REFRESH")
      this.user_id_local = this.$route.params.user_id
      this.getDataFromApi()
    },
  },
  methods: {
    ...mapActions([FETCH]),
    can_edit() {
      return this.$store.state.user.item.can_edit
    }
  },
}
</script>
